import { ChatType } from '../../types/monitor/ChatType';
import { FilterItem } from '../../components/filter-box/models/FilterBoxModel';
import { MonitorPeriod } from '../../types/monitor/MonitorPeriod';
import { t } from 'i18next';

export const getPeriodParam = (monitorPeriod: MonitorPeriod): string => {
  return monitorPeriod ? monitorPeriod.toLowerCase() : 'daily';
};

const getPeriodAndChatParam = (chat: ChatType | null, period: string): string => {
  const chatParam = chat ? chat.toLowerCase() : 'gpt';
  return `${period}/${chatParam}`;
};

export const periodFilter = (
  chat: ChatType | null,
  id: number,
  monitorPeriod: MonitorPeriod,
  url: string
): FilterItem[] => {
  return [
    {
      url: `${url}/${id}/${getPeriodAndChatParam(chat, 'daily')}`,
      label: t('dailyFilter'),
      isActive: monitorPeriod === 'DAILY',
    },
    {
      url: `${url}/${id}/${getPeriodAndChatParam(chat, 'weekly')}`,
      label: t('weeklyFilter'),
      isActive: monitorPeriod === 'WEEKLY',
    },
    {
      url: `${url}/${id}/${getPeriodAndChatParam(chat, 'monthly')}`,
      label: t('monthlyFilter'),
      isActive: monitorPeriod === 'MONTHLY',
    },
  ];
};
